module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/purebarre-4cbcf1d225282c54decfd883678b7bb4.png";